export const globalTranslationTable = {
  en: {
    Error: 'Error',
    Retry: 'Retry',
    Processing: 'Processing',
    Uploading: 'Uploading',
    Loading: 'Loading',
    Loading_Up: 'Loading up',
    Page_Not_Found: 'Page not found',
    Page_Not_Found_Message: 'Sorry about that! Try navigating using the link you received over email or SMS.',
    Feed_Conversation: 'Conversation',
    Feed_No_Comments_Yet: 'There are no comments yet.',
    Feed_Type_A_Message: 'Type a message...',
    Confirm_Log_Out_Msg: 'Are you sure you want to sign out?',
    Barcode_Field_Press_to_Scan: 'Press to scan a barcode',
    Barcode_Field_Default_Help_Text: 'Point your camera at a barcode to capture it. You may need to slightly adjust the angle and distance.',
    Barcode_Field_Move_Closer: 'Move closer',
    Barcode_Field_Hold_Steady: 'Hold steady',
    Barcode_Field_Error_No_Camera_Permission: 'The QR scanner could not start without permission to use the camera.',
    Barcode_Field_Error_No_Camera_Permission_Remedy: 'To fix this error, open your browser settings and enable camera permissions for {host} to scan a QR code.',
    Carrier_Search_Field_Placeholder: 'Search by name or DOT number',
    CRM_Search_Field_Placeholder: 'Search by name or DOT number',
    Select_Workflow: 'Select a workflow',
    Workflow_Empty_State_Tagline: 'Moving What The World Needs, Together',
    Mobile_Deeplink_Error_Description: 'There was an error loading this page',
    Entity_Search_Find: 'Find {entityDisplayName}',
    Entity_Search_Help_Text: 'Start typing a name, id, or keyword to search for {entityDisplayNamePlural}.',
    Entity_Search_Placeholder: 'Search {entityDisplayNamePlural}...',
    Entity_Search_Min_Characters: 'Type at least {minQueryLength} characters to search.',
    Entity_Search_Results: 'Results',
    Entity_Search_Results_For: 'Results for "{searchFilter}" (tap to select)',
    Entity_Search_No_Results: 'No results found for "{searchFilter}".',
  },
  es: {
    Error: 'Error',
    Retry: 'Reintentar',
    Processing: 'Procesando',
    Uploading: 'Enviando',
    Loading: 'Cargando',
    Loading_Up: 'Cargando',
    Page_Not_Found: 'Página no encontrada',
    Page_Not_Found_Message: '¡Lo sentimos! Intente navegar usando el hipervínculo que recibió por correo electrónico o SMS.',
    Feed_Conversation: 'Conversación',
    Feed_No_Comments_Yet: 'Todavía no hay comentarios.',
    Feed_Type_A_Message: 'Escribe un mensaje...',
    Confirm_Log_Out_Msg: '¿Estás seguro de que quieres cerrar sesión?',
    Barcode_Field_Press_to_Scan: 'Toca para escanear código',
    Barcode_Field_Default_Help_Text: 'Apunta tu cámara al código de barras para escanearlo. Tal vez tengas que moverla un poco para que se enfoque bien.',
    Barcode_Field_Move_Closer: 'Acércate más',
    Barcode_Field_Hold_Steady: 'No muevas la cámara',
    Barcode_Field_Error_No_Camera_Permission: 'El escáner QR no pudo iniciarse sin permiso para usar la cámara.',
    Barcode_Field_Error_No_Camera_Permission_Remedy: 'Para corregir este error, abra la configuración de su navegador y habilite los permisos de la cámara para que {host} escanear un código QR.',
    Carrier_Search_Field_Placeholder: 'Buscar por número DOT',
    CRM_Search_Field_Placeholder: 'Buscar por número DOT',
    Select_Workflow: 'Seleccione un flujo de trabajo',
    Workflow_Empty_State_Tagline: 'Moviendo lo que el mundo necesita, juntos',
    Mobile_Deeplink_Error_Description: 'Ocurrió un problema al cargar esta página',
    Entity_Search_Find: 'Buscar {entityDisplayName}',
    Entity_Search_Help_Text: 'Comienza escribiendo un nombre, identificador o palabra clave para buscar {entityDisplayNamePlural}.',
    Entity_Search_Placeholder: 'Buscar {entityDisplayNamePlural}...',
    Entity_Search_Min_Characters: 'Escribe al menos {minQueryLength} caracteres para buscar.',
    Entity_Search_Results: 'Resultados',
    Entity_Search_Results_For: 'Resultados para "{searchFilter}" (toca para seleccionar)',
    Entity_Search_No_Results: 'No se encontraron resultados para "{searchFilter}".',
  },
}
